import React, { useState } from 'react'
import { ChromePicker } from 'react-color'

interface IColorPickerProps {
  handleOk: (color: string) => void
  color?: string
}
const ColorPicker = (props: IColorPickerProps) => {
  const { handleOk, color } = props
  const [currentColor, setCurrentColor] = useState('#fff')
  const getTrueColor = color => {
    return color ? `rgba(${color.r},${color.g},${color.b},${color.a})` : ''
  }
  const handColorChange = color => {
    setCurrentColor(color.rgb)
    handleOk(getTrueColor(color.rgb))
  }
  const readColor = color => {
    if (!color) return
    if (color.r) return color
    const arr = color.replace('rgba(', '').replace(')', '').split(',')
    return {
      r: arr[0],
      g: arr[1],
      b: arr[2],
      a: arr[3],
    }
  }
  return (
    <div style={{ display: 'flex', justifyContent: 'center' }}>
      <ChromePicker
        color={currentColor === '#fff' ? readColor(color) : currentColor}
        onChange={color => handColorChange(color)}
      />
    </div>
  )
}

export default ColorPicker
